import {MouseEventHandler} from 'react';
import BottomButtonV4 from '../../common/component/BottomButtonV4';
import BottomButtonWrapperV4 from '../../common/component/BottomButtonWrapperV4';

interface IProps {
  currentSortLabel?: string;
  isHideSortButton: boolean;
  onClickEditButton: MouseEventHandler;
  onClickSort: MouseEventHandler;
}

export default function MyPageBottomButtonsV4({
  isHideSortButton,
  currentSortLabel,
  onClickEditButton,
  onClickSort,
}: IProps) {
  return (
    <BottomButtonWrapperV4>
      <BottomButtonV4 iconVariant="trash" onClick={onClickEditButton} />
      {!isHideSortButton && (
        <BottomButtonV4
          iconVariant="sort-up"
          onClick={onClickSort}
          text={currentSortLabel}
        />
      )}
    </BottomButtonWrapperV4>
  );
}
